(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-3tabfeature-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mq = matchMedia('(max-width: 749px)');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');

    const init = (root) => {
      if (root._ptfl) return;

      const list = root.querySelector('.ptfl__list');
      const items = [...list.children]; // real slides only (captured before cloning)
      const n = items.length;

      if (n < 2) {
        root.querySelectorAll('[data-ptfl-arrow]').forEach((a) => a.remove());
        return;
      }

      // ---- Infinite loop: [clone of last] [1 2 3 ...] [clone of first]
      const makeClone = (el) => {
        const c = el.cloneNode(true);
        [...c.attributes].forEach((a) => {
          if (a.name.startsWith('data-shopify') || a.name === 'id') c.removeAttribute(a.name);
        });
        c.classList.add('ptfl__item--clone');
        c.setAttribute('aria-hidden', 'true');
        return c;
      };
      const cloneFirst = makeClone(items[0]);
      const cloneLast = makeClone(items[n - 1]);
      list.prepend(cloneLast);
      list.append(cloneFirst);
      const all = [cloneLast, ...items, cloneFirst]; // real index r  ->  all[r + 1]

      const dots = [];
      const dotsWrap = root.querySelector('.ptfl__dots');
      const delay = (Number(root.dataset.speed) || 4) * 1000;
      const autoplay = 'autoplay' in root.dataset && !reduce.matches;

      let timer = 0;
      let visible = false;
      let paused = false;
      let touching = false;
      let settleTimer = 0;
      let current = 0; // real index 0..n-1

      const jumpTo = (allIdx) => {
        list.style.scrollSnapType = 'none';
        list.scrollTo({ left: allIdx * list.clientWidth, behavior: 'instant' });
        requestAnimationFrame(() => { list.style.scrollSnapType = ''; });
      };

      const goToAll = (allIdx) =>
        all[allIdx].scrollIntoView({
          behavior: reduce.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });

      const goTo = (realIdx) => goToAll(realIdx + 1);
      const step = (dir) => goToAll(current + 1 + dir); // can land on a clone (0 or n+1)

      const setActive = (i) => {
        if (dots.length) {
          dots[current]?.removeAttribute('aria-current');
          dots[i]?.setAttribute('aria-current', 'true');
        }
        current = i;
      };

      // After scrolling stops on a clone, silently jump to the matching real slide
      const settle = () => {
        if (touching || !mq.matches || !list.clientWidth) return;
        const idx = Math.round(Math.abs(list.scrollLeft) / list.clientWidth);
        if (idx === 0) jumpTo(n);          // clone of last  -> real last
        else if (idx === n + 1) jumpTo(1); // clone of first -> real first
      };
      const queueSettle = () => {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 120);
      };
      list.addEventListener('scroll', queueSettle, { passive: true });
      list.addEventListener('touchstart', () => { touching = true; }, { passive: true });
      list.addEventListener('touchend', () => { touching = false; queueSettle(); }, { passive: true });
      list.addEventListener('touchcancel', () => { touching = false; queueSettle(); }, { passive: true });

      // Start on the first real slide (clones are display:none on desktop)
      const resetPosition = () => {
        if (mq.matches) requestAnimationFrame(() => jumpTo(1));
      };
      resetPosition();
      mq.addEventListener('change', resetPosition);

      // Arrows
      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-ptfl-arrow]');
        if (btn) step(btn.dataset.ptflArrow === 'next' ? 1 : -1);
      });

      // Dots
      if (dotsWrap) {
        const frag = document.createDocumentFragment();
        items.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ptfl__dot';
          b.setAttribute('aria-label', `Go to item ${i + 1}`);
          dots.push(b);
          frag.append(b);
        });
        dotsWrap.append(frag);
        dotsWrap.addEventListener('click', (e) => {
          const i = dots.indexOf(e.target.closest('button'));
          if (i > -1) goTo(i);
        });
        setActive(0);
      }

      // Active slide tracking (clones map back to their real slide)
      const slideObserver = new IntersectionObserver(
        (entries) => {
          for (const e of entries) {
            if (!e.isIntersecting) continue;
            const idx = all.indexOf(e.target);
            const real = idx === 0 ? n - 1 : idx === n + 1 ? 0 : idx - 1;
            setActive(real);
          }
        },
        { root: list, threshold: 0.6 }
      );
      all.forEach((el) => slideObserver.observe(el));

      // Autoplay runs only when: mobile + in view + tab visible + not touched
      const sync = () => {
        const shouldRun = autoplay && mq.matches && visible && !paused && !document.hidden;
        if (shouldRun && !timer) {
          timer = setInterval(() => step(1), delay);
        } else if (!shouldRun && timer) {
          clearInterval(timer);
          timer = 0;
        }
      };

      let viewObserver;
      if (autoplay) {
        viewObserver = new IntersectionObserver(([e]) => {
          visible = e.isIntersecting;
          sync();
        });
        viewObserver.observe(root);

        const pause = () => { paused = true; sync(); };
        const resume = () => { paused = false; sync(); };
        const zone = root.querySelector('.ptfl__viewport');
        zone.addEventListener('pointerdown', pause, { passive: true });
        zone.addEventListener('pointerup', resume, { passive: true });
        zone.addEventListener('pointercancel', resume, { passive: true });
        zone.addEventListener('focusin', pause);
        zone.addEventListener('focusout', resume);
        mq.addEventListener('change', sync);
        document.addEventListener('visibilitychange', sync);
      }

      root._ptfl = () => {
        clearInterval(timer);
        clearTimeout(settleTimer);
        slideObserver.disconnect();
        viewObserver?.disconnect();
        mq.removeEventListener('change', resetPosition);
        mq.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        root._ptfl = null;
      };
    };

    const initAll = (scope = document) =>
      scope.querySelectorAll('[data-ptfl-carousel]').forEach(init);

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
      : initAll();

    // Theme editor support
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) =>
      e.target.querySelectorAll('[data-ptfl-carousel]').forEach((el) => el._ptfl?.())
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
